import React, { useState } from "react";
import Breadcrumb from "../../DefaultComponent/BreadCrumb";
import { Box, Button } from "@mui/material";
import ManualCreditGrant from "./ManualCreditGrant";

const GrantCreditsModal: React.FC = () => {
  const [openGrantDialog, setOpenGrantDialog] = useState(false);

  return (
    <>
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ p: 2 }}>
          <Breadcrumb
            pageTitle="Grant Credits Manually"
            breadcrumbs={[
              { label: "Payments", path: "#", isActive: false },
              {
                label: "Grant Credits Manually",
                path: "/payments/grant-credits",
                isActive: true,
              },
            ]}
          />
        </Box>

        <Box sx={{ m: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenGrantDialog(true)}
          >
            Grant Credits Manually
          </Button>
        </Box>
      </div>

      <ManualCreditGrant
        open={openGrantDialog}
        onClose={() => setOpenGrantDialog(false)}
      />
    </>
  );
};

export default GrantCreditsModal;
